import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';
import {ControlledNameStackingValidatorBuilder} from 'services/sports/nhl/validator/controlled-name-stacking-validator-builder';
import {NhlTeamStackingValidatorBuilder} from 'services/sports/nhl/validator/nhl-team-stacking-validator-builder';
import Action from 'actions';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            stacks: {nhlName: controlledNameStacking},
            nhlTeamStacking,
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (nhlTeamStacking.isEnabled()) {
            const nhlTeamStackingValidatorBuilder = new NhlTeamStackingValidatorBuilder().getInterface();
            validator.addSubValidators([nhlTeamStackingValidatorBuilder]);
        }

        if (controlledNameStacking.isEnabled()) {
            const controlledNameStackingValidatorBuilder = new ControlledNameStackingValidatorBuilder().getInterface();
            validator.addSubValidators([controlledNameStackingValidatorBuilder]);
        }

        return validator;
    }
}
